var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "size"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C19.4477 10 19 9.55229 19 9V6.41423L6.41423 19H9C9.55228 19 10 19.4477 10 20C10 20.5523 9.55228 21 9 21H5C3.89543 21 3 20.1046 3 19V15C3 14.4477 3.44772 14 4 14C4.55228 14 5 14.4477 5 15V17.5858L17.5858 5L15 5C14.4477 5 14 4.55228 14 4C14 3.44772 14.4477 3 15 3H19C20.1046 3 21 3.89543 21 5V9C21 9.55229 20.5523 10 20 10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 461 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H9C9.55228 3 10 3.44772 10 4C10 4.55228 9.55228 5 9 5H5V9C5 9.55228 4.55228 10 4 10C3.44772 10 3 9.55228 3 9V5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 465 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19C21 20.1046 20.1046 21 19 21H15C14.4477 21 14 20.5523 14 20C14 19.4477 14.4477 19 15 19H19V15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15V19Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/size.debb3e8fbe25eb1bdd7a9803ed206c7a.svg";
export { ForwardRef as ReactComponent };